import axios from 'axios'

export type AnalyticsSection = 'overview' | 'screens' | 'users' | 'features' | 'content' | 'performance' | 'realtime'

export type AnalyticsFilters = {
  from: string
  to: string
  company_guid?: string
  user_guid?: string
  path?: string
  kind?: 'dashboards' | 'reports'
}

const endpointBySection: Record<AnalyticsSection, string> = {
  overview: 'overview',
  screens: 'pages',
  users: 'users',
  features: 'features',
  content: 'content',
  performance: 'performance',
  realtime: 'realtime',
}

const toParams = (filters: AnalyticsFilters) => {
  const params = new URLSearchParams()
  params.set('from', `${filters.from}T00:00:00.000Z`)
  params.set('to', `${filters.to}T23:59:59.999Z`)
  if (filters.company_guid) params.set('company_guid', filters.company_guid)
  if (filters.user_guid) params.set('user_guid', filters.user_guid)
  if (filters.path) params.set('path', filters.path)
  if (filters.kind) params.set('kind', filters.kind)
  return params.toString()
}

const unwrap = (response: any) => {
  if (!response?.data?.success) {
    const error: any = new Error(response?.data?.error || 'ANALYTICS_UNAVAILABLE')
    error.code = response?.data?.error
    throw error
  }
  return response.data.data
}

export const getAnalyticsReport = async (section: AnalyticsSection, filters: AnalyticsFilters) => {
  const response = await axios.get(`/analytics/${endpointBySection[section]}?${toParams(filters)}`, {__loading: false} as any)
  return unwrap(response)
}

export const getAnalyticsFilters = async (filters: AnalyticsFilters) => {
  const response = await axios.get(`/analytics/filters?${toParams(filters)}`, {__loading: false} as any)
  return unwrap(response)
}
